document.addEventListener("DOMContentLoaded", function () {
  const searchInputs = document.querySelectorAll(".override-default-icon");
  const clearBtns = document.querySelectorAll(".clear-btn");

  if (!searchInputs.length || !clearBtns.length) return;

  function toggleClearButton() {
    searchInputs.forEach((input, index) => {
      const btn = clearBtns[index];
      if (btn) {
        btn.style.display = input.value.trim() ? "block" : "none";
      }
    });
  }

  // Clear button click
  clearBtns.forEach((btn, index) => {
    btn.addEventListener("click", function () {
      const input = searchInputs[index];
      if (input) {
        input.value = "";
        toggleClearButton();
        input.focus();
      }
    });
  });

  searchInputs.forEach((input) => {
    input.addEventListener("input", toggleClearButton);
  });

  toggleClearButton();
});
